export default function pojo(obj) {
  const pick = (...keys) =>
    keys.reduce(
      (final, k) => ({
        ...final,
        [k]: obj[k]
      }),
      {}
    );

  return { pick };
}



// WEBPACK FOOTER //
// ./app/lib/pojos.js